export default __webpack_public_path__ + "img/dfECkaPg.cc5d7dd1.svg";